import { observer } from 'mobx-react-lite';
import { withDefaultProps } from 'react-default-props-context';
import { AuthorT } from 'src/api/types/AuthorT';
import { cn } from 'src/frames/utils/cn';
import './AuthorView.scss';

type PropsT = {
  className?: any;
  author: AuthorT;
};

type DefaultPropsT = {};

export const AuthorView = observer(
  withDefaultProps<PropsT, DefaultPropsT>((props: PropsT & DefaultPropsT) => {
    return (
      <div className={cn('AuthorView', props.className)}>
        <div className={cn('AuthorView__Name')}>{props.author.name}</div>
        <div className={cn('AuthorView__Text', 'mt-2 mb-8')}>
          {props.author.text}
        </div>
      </div>
    );
  })
);
